import React, { useEffect, useState, forwardRef, useCallback } from 'react';
import { PostService } from '../services/post-service';
//import Debug from '../components/debug';
import HintError from '../components/hint-error';
import { useParams, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loading from "../components/layouts/loading";
import TitleGrows from "../components/title-grows";

//Snackbar
//import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import { useFormik } from 'formik';

export default function ArticleTagDetail() {

    const { id } = useParams();
    const [articletagCard, setArticletagCard] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState([]);

    const [state, setState] = useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
        message: '',
        severity: 'success',
        ahduration: 3000,
        instructions: ''
    });

    const { open, vertical, horizontal, message, severity, ahduration, instructions } = state;
    const Alert = forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    //Formik
    const formik = useFormik({
        initialValues: articletagCard,
        enableReinitialize: true,
        onSubmit: values => {
            alert(JSON.stringify(values, null, 2));
        },
    });

    const fetchData = useCallback(async (id) => {
        setIsLoading(true);
        let _articletagCard = await PostService.getTag(id);

        delete _articletagCard.id;
        setArticletagCard(_articletagCard);

        setIsLoading(false);
    }, [])

    useEffect(() => {
        fetchData(id);
    }, [id, fetchData]);

    async function save() {

        let imsg = null;
        let data = formik.values;

        try {
            //console.log('data: ', data);

            let resObject = await PostService.updateTag(id, data);
            let res = {
                tag: resObject.data,
                error_code: resObject.status,
                error_msg: resObject.data
            };
            if (!res || res.error_code !== 200) {
                console.log(`Error setTag: `, res.error_msg);
                //imsg = JSON.stringify(res.error_msg);
                setErrors(res.error_msg);
                setState({
                    open: true,
                    vertical: 'top',
                    horizontal: 'center',
                    message: 'Errore, non è stato possibile salvare!',
                    severity: 'error',
                    ahduration: null,
                    instructions: imsg
                });
                return {
                    revalidate: 5,
                    notFound: true,
                }
            }
            setState({
                open: true,
                vertical: 'top',
                horizontal: 'center',
                message: 'Salvato correttamente!',
                severity: 'success',
                ahduration: 2000,
                instructions: null
            })
            console.log(`Result of PUT:`, res.tag);
            setErrors([]);
            fetchData(id);
        } catch (e) {
            console.log(e);
            return {
                revalidate: 5,
                notFound: true,
            }
        }
    }

    const handleClose = () => {
        setState({ ...state, open: false });
    };

    return articletagCard && (
        <>
            <TitleGrows txtTitle={'Article tag detail'} />
            {isLoading ? <Loading /> :
                <>
                    <div className="card mybox w-100">
                        <div className="card-body">
                            <span style={{ position: "absolute", right: "20px" }}>
                                id: {id}
                            </span>
                            <div className="card-title">
                                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                                    <div className="col-12">
                                        <span className="fw-bold">
                                            <FontAwesomeIcon icon={['fas', 'asterisk']} size={'1x'} color={'red'} />
                                            &nbsp;Name: <HintError errors={errors?.name} ></HintError></span>

                                        <input type="text" id="name" className="form-control" autoFocus
                                            style={{ width: "100%", border: errors?.name ? "2px solid red" : '' }}
                                            onChange={formik.handleChange}
                                            value={formik.values.name}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="card-title">
                                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                                    <div className="col-12">
                                        <span className="fw-bold">
                                            <FontAwesomeIcon icon={['fas', 'asterisk']} size={'1x'} color={'red'} />
                                            &nbsp;Slug: <HintError errors={errors?.slug} ></HintError></span>

                                        <input type="text" id="slug" className="form-control" style={{ width: "100%", border: errors?.slug ? "2px solid red" : '' }}
                                            onChange={formik.handleChange}
                                            value={formik.values.slug}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="card-title">
                                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                                    <div className="col-12">
                                        <span className="fw-bold">Image background url:</span>
                                        <input type="text" id="image_bk_url" className="form-control" style={{ width: "100%" }}
                                            onChange={formik.handleChange}
                                            value={formik.values.image_bk_url}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="card-title">
                                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                                    <div className="col-12">
                                        <span className="fw-bold">Image background url 4_3:</span>
                                        <input type="text" id="image_bk_url_4_3" className="form-control" style={{ width: "100%" }}
                                            onChange={formik.handleChange}
                                            value={formik.values.image_bk_url_4_3}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="card-title">
                                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                                    <div className="col-12">
                                        <span className="fw-bold">Excerpt:</span>
                                        <input type="text" id="excerpt" className="form-control" style={{ width: "100%" }}
                                            onChange={formik.handleChange}
                                            value={formik.values.excerpt}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="card-title">
                                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                                    <div className="col-12">
                                        <span className="fw-bold">Color bar:</span>
                                        <input type="text" id="color" className="form-control" style={{ width: "100%" }}
                                            onChange={formik.handleChange}
                                            value={formik.values.color}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ margin: "12px" }}>
                            <div className="d-grid gap-2 d-md-block">
                                <div className="row">
                                    <div className="col-12">
                                        <button type="button" onClick={() => save()} className="btn btn-primary" style={{ width: "6rem", float: "right" }}>Salva</button>
                                        <span style={{ color: "red", float: "right", margin: "16px 10px 0px 0px" }}>
                                            <FontAwesomeIcon icon={['fas', 'asterisk']} size={'1x'} color={'red'} />
                                            <span className="user-select-none">Indica un campo obbligatorio</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{ textAlign: "center", marginTop: "10px" }}>
                        <Link to={{ pathname: "/articlestags" }}>
                            Torna alla lista dei tag
                        </Link>
                    </div>
                    <Snackbar open={open} autoHideDuration={ahduration} onClose={handleClose}
                        anchorOrigin={{ vertical, horizontal }} >
                        <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                            <div style={{ textAlign: "center" }}>{message}</div>
                            {instructions ?
                                <Alert severity="info" sx={{ margin: "10px 0 0 0" }}>
                                    {instructions}
                                </Alert>
                                : ''}
                        </Alert>
                    </Snackbar>
                    {/* <Debug obj={articletagCard} name={"ltCard"}></Debug>
                    <Debug obj={formik.values} name={"formik.values"}></Debug> */}
                </>
            }
        </>
    );

}